import styled, { css } from "styled-components";

import {
  DeleteButton,
  DeleteButtonWrapper,
  FixedWrapper,
} from "@FillInTableContainer/shared/styles/deleteButton.style";
import {
  DefaultDraggableGroupShellWrapper,
  GroupShellTitleWrapper,
  OutsideWrapper,
} from "@FillInTableContainer/shared/styles/groupShell.style";
import {
  SelectButton,
  SelectButtonDivider,
  SelectButtonDividerWrapper,
  SelectContentWrapper,
} from "@FillInTableContainer/shared/styles/rowSelectButton.style";

export const GroupShellOutsideWrapper = styled.div`
  position: relative;
  padding-left: 0;
  margin-top: 3.2rem;
`;

export const GroupShellWrapper = styled(OutsideWrapper)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 0;
`;

export const GroupShell = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FixedDeleteButtonWrapper = styled(FixedWrapper)<{
  isShellTitle?: boolean;
}>`
  top: -2.4rem;
  left: -0.2rem;
  right: auto;

  ${({ isShellTitle }) =>
    isShellTitle &&
    css`
      top: -2.4rem;
      left: -0.2rem;
    `}
`;

export const SubGroupShellDivider = styled.div`
  width: 100%;
  height: 0.2rem;
  background: var(--Color-Common-Border-Tertiary, #e5e7eb);
`;

export const DeleteTableButtonWrapper = styled(DeleteButtonWrapper)``;

export const DeleteTableButton = styled(DeleteButton)``;

export const SelectWrapper = styled(SelectContentWrapper)`
  background-color: #f8f9fa;
  padding: 0;
`;

export const GroupShellSelectButton = styled(SelectButton)``;

export const GroupShellSelectButtonDivider = styled(SelectButtonDivider)``;

export const GroupShellSelectButtonDividerWrapper = styled(
  SelectButtonDividerWrapper,
)<{ isFinancialTerms: boolean }>`
  ${({ isFinancialTerms }) =>
    isFinancialTerms &&
    css`
      display: none;
    `}
`;
export const TitleWrapper = styled(GroupShellTitleWrapper)`
  background-color: transparent;
`;

export const DraggableSubGroupShellWrapper = styled(
  DefaultDraggableGroupShellWrapper,
)`
  position: relative;
`;

export const GroupShellHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  padding-left: 3.6rem;
  border: 2px solid transparent;
`;

export const GroupShellHeader = styled.div<{
  minWidth: string;
  maxWidth: string;
}>`
  display: flex;
  min-width: ${({ minWidth }) => minWidth};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  padding: 0.6rem 0.8rem 0.6rem var(--Spacing-8, 0.8rem);
  align-items: flex-start;
  flex: 1 0 0;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;
  background-color: #fff;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
`;

export const ContentsWrapper = styled.div`
  width: 100%;
  padding-bottom: 0.8rem;
  background-color: #f8f9fa;
`;
